/**
 * Calendar-date helpers.
 *
 * DO NOT replace toLocalDateString with date.toISOString().split("T")[0].
 * That is the bug this file exists to prevent, and it is invisible for half
 * the year.
 *
 * The Date objects our calendar grids produce are LOCAL midnight — new
 * Date(2026, 7, 1) is 2026-08-01T00:00 in whatever zone the browser is in.
 * toISOString() converts to UTC first. Under British Summer Time (UTC+1)
 * local midnight is 23:00 UTC on the PREVIOUS day, so the ISO string reads
 * 2026-07-31 and every date seeded through it lands one day early.
 *
 * Seasonality is why this is worth a comment: BST runs from the last Sunday
 * in March to the last Sunday in October. Outside that window the UK is on
 * GMT, local and UTC coincide, and the bug is completely unreproducible.
 * If you are reading this in January and the ISO one-liner looks fine to
 * you — it is fine, today. It breaks again at the end of March.
 *
 * Building the string from the local getFullYear/getMonth/getDate
 * components never crosses a zone boundary, so it is correct year-round.
 */

/** Format a Date as YYYY-MM-DD using its LOCAL calendar components. */
export function toLocalDateString(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Parse a YYYY-MM-DD string to local midnight. new Date(str) would give UTC midnight. */
export function fromLocalDateString(str) {
  const [y, m, d] = str.split("-").map(Number);
  return new Date(y, m - 1, d);
}
